module.exports = __webpack_public_path__ + "img/spirespylogo-square.42ed0edb.png";